// src/components/features/PathfinderModules/PathfinderJourneyStageProgressionBoxes.js

import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom'; // Added Link
import useCachedSubscription from '../../../hooks/useCachedSubscription'; // Added hook
import IMTSubsteps from '../../../data/PathfinderData/IMT/IMT_Max_Substeps.json';
import CSTSubsteps from '../../../data/PathfinderData/CST/CST_Max_Substeps.json';
import ACCSSubsteps from '../../../data/PathfinderData/ACCS/ACCS_Max_Substeps.json';
import NeurosurgerySubsteps from '../../../data/PathfinderData/Neurosurgery/NeuroSurg_Max_Substeps.json';
import RadiologySubsteps from '../../../data/PathfinderData/Radiology/Radiology_Max_Substeps.json';
// Import the domain-specific task details JSON files
import CSTTaskDetails_OperativeExperience from '../../../data/PathfinderData/CST/CST_TaskDetails_OperativeExperience.json';
import CSTTaskDetails_SurgicalExperience from '../../../data/PathfinderData/CST/CST_TaskDetails_SurgicalExperience.json';
import CSTTaskDetails_QualityImprovementAudit from '../../../data/PathfinderData/CST/CST_TaskDetails_QualityImprovementAudit.json';
import CSTTaskDetails_PresentationsPublications from '../../../data/PathfinderData/CST/CST_TaskDetails_PresentationsPublications.json';
import CSTTaskDetails_TeachingExperience from '../../../data/PathfinderData/CST/CST_TaskDetails_TeachingExperience.json';
import IMTTaskDetails_MRCP from '../../../data/PathfinderData/IMT/IMT_TaskDetails_TrainingInTeaching.json';
import IMTTaskDetails_PostgraduateDegrees from '../../../data/PathfinderData/IMT/IMT_TaskDetails_PostgraduateDegrees.json';
import IMTTaskDetails_PresentationsPosters from '../../../data/PathfinderData/IMT/IMT_TaskDetails_PresentationsPosters.json';
import IMTTaskDetails_Publications from '../../../data/PathfinderData/IMT/IMT_TaskDetails_Publications.json';
import IMTTaskDetails_QualityImprovement from '../../../data/PathfinderData/IMT/IMT_TaskDetails_QualityImprovement.json';
import IMTTaskDetails_TeachingExperience from '../../../data/PathfinderData/IMT/IMT_TaskDetails_TeachingExperience.json';
import ACCSTaskDetails_MSRA_ClinicalProblemSolving from '../../../data/PathfinderData/ACCS/ACCS_TaskDetails_MSRA_ClinicalProblemSolving.json';
import ACCSTaskDetails_MSRA_ProfessionalDilemmas from '../../../data/PathfinderData/ACCS/ACCS_TaskDetails_MSRA_ProfessionalDilemmas.json';
import ACCSTaskDetails_Interview_CommitmentToSpecialty from '../../../data/PathfinderData/ACCS/ACCS_TaskDetails_Interview_CommitmentToSpecialty.json';
import ACCSTaskDetails_Interview_TeamworkAndStress from '../../../data/PathfinderData/ACCS/ACCS_TaskDetails_Interview_TeamworkAndStress.json';
import ACCSTaskDetails_Interview_TeachingAndQI from '../../../data/PathfinderData/ACCS/ACCS_TaskDetails_Interview_TeachingAndQI.json';
import ACCSTaskDetails_Interview_EMKnowledge from '../../../data/PathfinderData/ACCS/ACCS_TaskDetails_Interview_EMKnowledge.json';
import ACCSTaskDetails_Interview_ClinicalScenarios from '../../../data/PathfinderData/ACCS/ACCS_TaskDetails_Interview_ClinicalScenarios.json';
import NeuroSurg_TaskDetails_FirstDegreeinMedSci from '../../../data/PathfinderData/Neurosurgery/NeuroSurg_TaskDetails_FirstDegreeinMedSci.json';
import NeuroSurg_TaskDetails_HigherDegree from '../../../data/PathfinderData/Neurosurgery/NeuroSurg_TaskDetails_HigherDegree.json';
import NeuroSurg_TaskDetails_Organisational from '../../../data/PathfinderData/Neurosurgery/NeuroSurg_TaskDetails_Organisational.json';
import NeuroSurg_TaskDetails_OtherDegrees from '../../../data/PathfinderData/Neurosurgery/NeuroSurg_TaskDetails_OtherDegrees.json';
import NeuroSurg_TaskDetails_PersonalStatement from '../../../data/PathfinderData/Neurosurgery/NeuroSurg_TaskDetails_PersonalStatement.json';
import NeuroSurg_TaskDetails_PostgraduateAwards from '../../../data/PathfinderData/Neurosurgery/NeuroSurg_TaskDetails_PostgraduateAwards.json';
import NeuroSurg_TaskDetails_PostgraduateClinCourses from '../../../data/PathfinderData/Neurosurgery/NeuroSurg_TaskDetails_PostgraduateClinCourses.json';
import NeuroSurg_TaskDetails_PostgraduateResearch from '../../../data/PathfinderData/Neurosurgery/NeuroSurg_TaskDetails_PostgraduateResearch.json';
import NeuroSurg_TaskDetails_Presentations from '../../../data/PathfinderData/Neurosurgery/NeuroSurg_TaskDetails_Presentations.json';
import NeuroSurg_TaskDetails_Psychomotor from '../../../data/PathfinderData/Neurosurgery/NeuroSurg_TaskDetails_Psychomotor.json';
import NeuroSurg_TaskDetails_Publications from '../../../data/PathfinderData/Neurosurgery/NeuroSurg_TaskDetails_Publications.json';
import NeuroSurg_TaskDetails_QIP from '../../../data/PathfinderData/Neurosurgery/NeuroSurg_TaskDetails_QIP.json';
import NeuroSurg_TaskDetails_Teaching from '../../../data/PathfinderData/Neurosurgery/NeuroSurg_TaskDetails_Teaching.json';
import NeuroSurg_TaskDetails_UndergraduateCareer from '../../../data/PathfinderData/Neurosurgery/NeuroSurg_TaskDetails_UndergraduateCareer.json';
import NeuroSurg_TaskDetails_UndergraduateElectives from '../../../data/PathfinderData/Neurosurgery/NeuroSurg_TaskDetails_UndergraduateElectives.json';
import Radiology_TaskDetails_AcademicAchieve from '../../../data/PathfinderData/Radiology/Radiology_TaskDetails_AcademicAchieve.json';
import Radiology_TaskDetails_Audit from '../../../data/PathfinderData/Radiology/Radiology_TaskDetails_Audit.json';
import Radiology_TaskDetails_Commitment from '../../../data/PathfinderData/Radiology/Radiology_TaskDetails_Commitment.json';
import Radiology_TaskDetails_Leadership from '../../../data/PathfinderData/Radiology/Radiology_TaskDetails_Leadership.json';
import Radiology_TaskDetails_TeachTrain from '../../../data/PathfinderData/Radiology/Radiology_TaskDetails_TeachTrain.json';
import { getCurrentUser } from 'aws-amplify/auth';
import { saveIMTDomainProgress, fetchIMTDomainsProgress } from '../../../api/imtProgressApi';
import { saveCSTDomainProgress, fetchCSTDomainsProgress } from '../../../api/cstProgressApi';
import { saveACCSDomainProgress, fetchACCSDomainsProgress } from '../../../api/accsProgressApi';
import { saveNeuroSurgDomainProgress, fetchNeuroSurgDomainsProgress } from '../../../api/neuroSurgProgressApi';
import { saveRadiologyDomainProgress, fetchRadiologyDomainsProgress } from '../../../api/RadiologyProgressApi';
import { recordDailyActivity } from '../../../api/dailyActivityApi';
import {
  FaUserMd, 
  FaGraduationCap, 
  FaChalkboardTeacher,
  FaClipboardList,
  FaChartLine,
  FaBook,
  FaCertificate,
  FaUndo,
  FaCog,
  FaHospitalUser,
  FaBriefcaseMedical,
  FaHandHoldingMedical,
  FaNotesMedical,
  FaLock, // Added FaLock
  FaMedal, // Added FaMedal
  FaDesktop,
  FaFile,
  FaFileAlt // Added FaFileAlt
} from 'react-icons/fa';
import { FaQuestionCircle } from 'react-icons/fa'; // Fallback icon

const colorMap = {
  category1: '#4299E1',
  category2: '#48BB78',
  category3: '#ED8936',
  category4: '#9F7AEA',
  category5: '#F56565',
  category6: '#38B2AC',
  category7: '#667EEA',
  // Extended colors for large number of categories in Neurosurgery
  category8: '#D53F8C',
  category9: '#DD6B20',
  category10: '#319795',
  category11: '#3182CE',
  category12: '#805AD5',
  category13: '#E53E3E',
  category14: '#D69E2E',
  category15: '#718096',
  category16: '#00B5D8'
};

const iconMap = {
  category1: FaUserMd,
  category2: FaGraduationCap,
  category3: FaChalkboardTeacher,
  category4: FaBook,
  category5: FaChartLine,
  category6: FaClipboardList,
  category7: FaCertificate,
};

const iconMapCST = {
  category1: FaCog || FaUserMd,
  category2: FaGraduationCap,
  category3: FaHandHoldingMedical || FaChalkboardTeacher,
  category4: FaNotesMedical || FaBook,
  category5: FaChartLine,
  category6: FaBriefcaseMedical || FaClipboardList,
  category7: FaHospitalUser || FaCertificate,
};

// Add ACCS icons
const iconMapACCS = {
  category1: FaUserMd,
  category2: FaGraduationCap,
  category3: FaChalkboardTeacher,
  category4: FaChartLine,
  category5: FaClipboardList,
  category6: FaHospitalUser,
  category7: FaBriefcaseMedical,
};

const iconMapNeurosurgery = {
  category1: FaGraduationCap, 
  category2: FaHospitalUser,
  category3: FaGraduationCap,
  category4: FaGraduationCap,
  category5: FaCertificate,
  category6: FaChartLine,
  category7: FaMedal,
  category8: FaBook,
  category9: FaFile,
  category10: FaDesktop,
  category11: FaClipboardList,
  category12: FaUserMd,
  category13: FaBriefcaseMedical,
  category14: FaChalkboardTeacher,
  category15: FaFileAlt,
  category16: FaHospitalUser,
};

const iconMapRadiology = {
  category1: FaHandHoldingMedical, // Commitment
  category2: FaUserMd,             // Leadership
  category3: FaChalkboardTeacher,  // Teaching
  category4: FaClipboardList,      // Audit/QI
  category5: FaGraduationCap,      // Academic
};

const ProgressBar = ({ progress, total, color }) => {
  const percentage = (progress / total) * 100;
  
  return (
    <div className="progress-container">
      <div className="progress-info">
        <span className="progress-label" style={{ color }}>Progress</span>
        <span className="progress-text" style={{ color }}>{progress}/{total}</span>
      </div>
      <div className="progress-track">
        <div 
          className="progress-fill"
          style={{ 
            width: `${percentage}%`,
            backgroundColor: color,
            boxShadow: `0 0 10px ${color}66`
          }}
        />
      </div>
      <style jsx>{`
        .progress-container {
          display: flex;
          flex-direction: column;
          gap: 0.35rem;
          padding: 0.5rem 0.75rem;
          border-radius: 16px;
          transition: all 0.2s ease;
          margin-bottom: 0.5rem;
          background: rgba(255, 255, 255, 0.3);
          backdrop-filter: blur(8px);
          border: 1px solid rgba(255, 255, 255, 0.4);
          box-shadow: 0 2px 10px rgba(0,0,0,0.02);
        }

        .progress-info {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 2px;
        }

        .progress-label {
          font-size: 0.65rem;
          font-weight: 700;
          letter-spacing: 0.05em;
          text-transform: uppercase;
          opacity: 0.9;
        }

        .progress-text {
          font-size: 0.75rem;
          font-weight: 700;
          font-variant-numeric: tabular-nums;
        }

        .progress-track {
          height: 6px;
          background: rgba(0,0,0,0.05);
          border-radius: 10px;
          overflow: hidden;
          box-shadow: inset 0 1px 2px rgba(0,0,0,0.05);
          border: 1px solid rgba(255,255,255,0.2);
        }

        .progress-fill {
          height: 100%;
          border-radius: 10px;
          transition: width 0.8s cubic-bezier(0.34, 1.56, 0.64, 1);
          position: relative;
          overflow: hidden;
        }
        
        .progress-fill::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          background: linear-gradient(
            90deg,
            rgba(255,255,255,0) 0%,
            rgba(255,255,255,0.4) 50%,
            rgba(255,255,255,0) 100%
          );
          transform: translateX(-100%);
          animation: shimmer 2.5s infinite;
        }

        @keyframes shimmer {
          100% {
            transform: translateX(100%);
          }
        }
      `}</style>
    </div>
  );
};

const PathfinderJourneyStageProgressionBoxes = ({
  stages,
  toggleTask,
  revertStage,
  totalWidth,
  translateX,
  trainingPath = 'IMT', // Default to IMT
  onOpenTask, // NEW: parent-provided handler to open central modal with task details
}) => {
  const { subscription } = useCachedSubscription();
  const isSubscribed = ['active', 'trialing'].includes(subscription?.status);

  const [taskProgress, setTaskProgress] = useState({});
  const [fading, setFading] = useState({});
  const fadeTimeout = useRef({});
  const [stepsData, setStepsData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [loadingError, setLoadingError] = useState(null);
  const [notification, setNotification] = useState({
    show: false,
    message: '',
    type: 'success'
  });
  const notificationTimeout = useRef(null);
  const [confirmUndo, setConfirmUndo] = useState({ show: false, categoryIndex: null });
  // ...existing code...

  // Combine CST task details into a single object for easier lookup
  const cstTaskDetails = {
    ...CSTTaskDetails_OperativeExperience,
    ...CSTTaskDetails_SurgicalExperience,
    ...CSTTaskDetails_QualityImprovementAudit,
    ...CSTTaskDetails_PresentationsPublications,
    ...CSTTaskDetails_TeachingExperience
    // ...import and spread other CST detail files here as they are created
  };

  // Combine IMT task details into a single object
  const imtTaskDetails = {
    ...IMTTaskDetails_MRCP,
    ...IMTTaskDetails_PostgraduateDegrees,
    ...IMTTaskDetails_PresentationsPosters,
    ...IMTTaskDetails_Publications,
    ...IMTTaskDetails_QualityImprovement,
    ...IMTTaskDetails_TeachingExperience
    // ...import and spread other IMT detail files here as they are created
  };

  // Combine ACCS task details into a single object
  const accsTaskDetails = {
    ...ACCSTaskDetails_MSRA_ClinicalProblemSolving,
    ...ACCSTaskDetails_MSRA_ProfessionalDilemmas,
    ...ACCSTaskDetails_Interview_CommitmentToSpecialty,
    ...ACCSTaskDetails_Interview_TeamworkAndStress,
    ...ACCSTaskDetails_Interview_TeachingAndQI,
    ...ACCSTaskDetails_Interview_EMKnowledge,
    ...ACCSTaskDetails_Interview_ClinicalScenarios
    // ...import and spread other ACCS detail files here as they are created
  };

  // Combine Neurosurgery task details into a single object
  const neuroTaskDetails = {
    ...NeuroSurg_TaskDetails_FirstDegreeinMedSci,
    ...NeuroSurg_TaskDetails_HigherDegree,
    ...NeuroSurg_TaskDetails_Organisational,
    ...NeuroSurg_TaskDetails_OtherDegrees,
    ...NeuroSurg_TaskDetails_PersonalStatement,
    ...NeuroSurg_TaskDetails_PostgraduateAwards,
    ...NeuroSurg_TaskDetails_PostgraduateClinCourses,
    ...NeuroSurg_TaskDetails_PostgraduateResearch,
    ...NeuroSurg_TaskDetails_Presentations,
    ...NeuroSurg_TaskDetails_Psychomotor,
    ...NeuroSurg_TaskDetails_Publications,
    ...NeuroSurg_TaskDetails_QIP,
    ...NeuroSurg_TaskDetails_Teaching,
    ...NeuroSurg_TaskDetails_UndergraduateCareer,
    ...NeuroSurg_TaskDetails_UndergraduateElectives
    // ...import and spread other Neurosurgery detail files here as they are created
  };

  // Combine Radiology task details into a single object
  const radiologyTaskDetails = {
    ...Radiology_TaskDetails_AcademicAchieve,
    ...Radiology_TaskDetails_Audit,
    ...Radiology_TaskDetails_Commitment,
    ...Radiology_TaskDetails_Leadership,
    ...Radiology_TaskDetails_TeachTrain
  };

  // Load the appropriate steps data based on the training path
  useEffect(() => {
    // Reset progress when training path changes
    setIsLoading(true);
    setLoadingError(null);
    
    // Select the appropriate data based on the training path
    let selectedData;
    if (trainingPath === 'ACCS') {
      selectedData = ACCSSubsteps;
    } else if (trainingPath === 'CST') {
      selectedData = CSTSubsteps;
    } else if (trainingPath === 'Neurosurgery') {
      selectedData = NeurosurgerySubsteps;
    } else if (trainingPath === 'Radiology') {
      selectedData = RadiologySubsteps;
    } else {
      selectedData = IMTSubsteps; // Default to IMT
    }
    setStepsData(selectedData);
  }, [trainingPath]);

  // Load saved progress when component mounts or training path changes
  useEffect(() => {
    const loadSavedProgress = async () => {
      try {
        setIsLoading(true);
        
        let savedProgress = [];
        
        // Use the appropriate API based on training path
        if (trainingPath === 'IMT') {
          savedProgress = await fetchIMTDomainsProgress();
        } else if (trainingPath === 'CST') {
          savedProgress = await fetchCSTDomainsProgress();
        } else if (trainingPath === 'ACCS') {
          savedProgress = await fetchACCSDomainsProgress();
        } else if (trainingPath === 'Neurosurgery') {
          savedProgress = await fetchNeuroSurgDomainsProgress();
        } else if (trainingPath === 'Radiology') {
          savedProgress = await fetchRadiologyDomainsProgress();
        }
        
        if (savedProgress && savedProgress.length > 0) {
          // Convert the array of domain progress objects to a mapping by domainKey
          const progressMap = {};
          savedProgress.forEach(item => {
            progressMap[item.domainKey] = item.progress;
          });
          
          setTaskProgress(progressMap);
          console.log(`Loaded saved ${trainingPath} progress:`, progressMap);
          
          // Remove popup when progress loads
          // showNotification('Your progress was loaded successfully!', 'info');
        }
      } catch (error) {
        console.error(`Error loading saved ${trainingPath} progress:`, error);
        setLoadingError(`Failed to load your ${trainingPath} progress`);
      } finally {
        setIsLoading(false);
      }
    };
    
    if (stepsData) {
      loadSavedProgress();
    }
  }, [stepsData, trainingPath]);
  
  // Function to display notifications
  const showNotification = (message, type = 'success') => {
    // Clear any existing timeout to prevent issues
    if (notificationTimeout.current) {
      clearTimeout(notificationTimeout.current);
    }
    
    // Set the notification
    setNotification({
      show: true,
      message,
      type
    });
    
    // Hide notification after 3 seconds
    notificationTimeout.current = setTimeout(() => {
      setNotification(prev => ({ ...prev, show: false }));
    }, 3000);
  };

  const startFadeTimer = (categoryIndex) => {
    clearTimeout(fadeTimeout.current[categoryIndex]);
    setFading(prev => ({ ...prev, [categoryIndex]: false }));

    fadeTimeout.current[categoryIndex] = setTimeout(() => {
      setFading(prev => ({ ...prev, [categoryIndex]: true }));
    }, 2000);
  };

  // Flatten all sub-steps so each category shows 25 steps in order
  const flattenSteps = (SMARTSteps) => {
    return SMARTSteps.flatMap(phase => phase.SubSteps);
  };

  // Only process steps if stepsData is available
  const allSteps = stepsData ? Object.keys(stepsData).map((category, index) => {
    const steps = flattenSteps(stepsData[category].SMARTSteps);
    let iconSet;
    
    // Select icon set based on training path
    if (trainingPath === 'ACCS') {
      iconSet = iconMapACCS;
    } else if (trainingPath === 'CST') {
      iconSet = iconMapCST;
    } else if (trainingPath === 'Neurosurgery') {
      iconSet = iconMapNeurosurgery;
    } else if (trainingPath === 'Radiology') {
      iconSet = iconMapRadiology;
    } else {
      iconSet = iconMap; // Default to IMT icons
    }

    // Resolve icon with fallback and logging
    let IconComponent = iconSet[`category${index + 1}`] || iconMap[`category${index + 1}`];
    
    if (!IconComponent) {
      console.warn(`PathfinderJourneyStageProgressionBoxes: Missing icon for ${trainingPath} category${index + 1}. using fallback.`);
      IconComponent = FaQuestionCircle;
    }

    return {
      category,
      steps,
      color: colorMap[`category${index + 1}`],
      icon: IconComponent,
    };
  }) : [];

  // Helper function to convert categoryIndex to appropriate domain key string
  const getDomainKeyFromIndex = (categoryIndex) => {
    // Use the appropriate domain keys array based on training path
    if (trainingPath === 'IMT') {
      const imtDomainKeys = [
        "MRCP(UK)",
        "Postgraduate Degrees",
        "Presentations/Posters",
        "Publications",
        "Quality Improvement",
        "Teaching Experience",
        "Additional Error for IMT"
      ];
      return imtDomainKeys[categoryIndex];
    } else if (trainingPath === 'CST') {
      const cstDomainKeys = [
        "Operative Experience",
        "Surgical Experience",
        "Quality Improvement/Audit",
        "Presentations/Publications",
        "Teaching Experience"
      ];
      return cstDomainKeys[categoryIndex];
    } else if (trainingPath === 'ACCS') {
      const accsDomainKeys = [
        "MSRA: Clinical Problem Solving",
        "MSRA: Professional Dilemmas",
        "Interview: Commitment to Specialty",
        "Interview: Teamwork & Stress",
        "Interview: Teaching & QI",
        "Interview: EM Knowledge",
        "Interview: Clinical Scenarios"
      ];
      return accsDomainKeys[categoryIndex];
    } else if (trainingPath === 'Neurosurgery') {
      const neuroDomainKeys = [
        "Undergraduate Career (research, audit, QI, prizes/awards)",
        "Undergraduate clinical electives and attachments",
        "Higher Degree (full-time original research e.g. PhD/MD/Masters by research; excluding degrees integral to curriculum)",
        "First Degree in Medical Sciences (e.g. BSc/BMedSci/MRes; excluding intercalated degrees as part of medical course)",
        "Other Degrees and Diplomas",
        "Postgraduate Research",
        "Postgraduate Academic Awards and Prizes",
        "Postgraduate Clinical Courses (including neurosurgery-relevant and surgical skills courses)",
        "Publications (accepted for publication as a minimum standard)",
        "Presentations",
        "Clinical Audit and Quality Improvement Projects",
        "Organisational and Leadership Skills (including management experience and understanding of NHS management/resources)",
        "Operative Experience (including validated logbook documentation of surgical exposure)",
        "Teaching (including experience of teaching and communication to a range of audiences)",
        "Personal Statement 1 (demonstrating insight, commitment, understanding of programme, and NHS values)",
        "Surgical Placement Experience in Neurosurgery and Allied Specialties"
      ];
      return neuroDomainKeys[categoryIndex];
    } else if (trainingPath === 'Radiology') {
      const radiologyDomainKeys = [
        "Commitment to Specialty (double-weighted domain)",
        "Leadership and Management (minimum role duration 6 months)",
        "Teaching and Training",
        "Audit and Quality Improvement",
        "Academic Achievements (postgraduate achievements only for scoring)"
      ];
      return radiologyDomainKeys[categoryIndex];
    }
    
    return `Unknown domain ${categoryIndex}`;
  };

  const getCurrentTaskIndex = (categoryIndex) => {
    // First try to get progress using the text domain key
    const domainKey = getDomainKeyFromIndex(categoryIndex);
    
    // Check if we have progress for this domain key
    if (taskProgress[domainKey] !== undefined) {
      return taskProgress[domainKey];
    }
    
    // Fall back to numeric index if text key not found (backward compatibility)
    return taskProgress[categoryIndex] || 0;
  };

  const handleTaskComplete = async (categoryIndex, taskIndex) => {
    // Get the appropriate domain key
    const domainKey = getDomainKeyFromIndex(categoryIndex);
    
    // Update local state using the text domain key
    const newProgress = {
      ...taskProgress,
      [domainKey]: (taskProgress[domainKey] || 0) + 1
    };
    
    setTaskProgress(newProgress);
    startFadeTimer(categoryIndex);
    
    // Save progress to backend using the text domain key
    try {
      console.log(`Attempting to save ${trainingPath} progress for ${domainKey}: ${newProgress[domainKey]}`);
      let result;
      if (trainingPath === 'IMT') {
        result = await saveIMTDomainProgress(domainKey, newProgress[domainKey]);
      } else if (trainingPath === 'CST') {
        result = await saveCSTDomainProgress(domainKey, newProgress[domainKey]);
      } else if (trainingPath === 'ACCS') {
        result = await saveACCSDomainProgress(domainKey, newProgress[domainKey]);
      } else if (trainingPath === 'Neurosurgery') {
        result = await saveNeuroSurgDomainProgress(domainKey, newProgress[domainKey]);
      } else if (trainingPath === 'Radiology') {
        result = await saveRadiologyDomainProgress(domainKey, newProgress[domainKey]);
      }
      // Remove success popup on task completion
      // showNotification('Progress saved successfully!');
      console.log(`${trainingPath} progress saved for ${domainKey}: ${newProgress[domainKey]}`, result);
      recordDailyActivity('task_complete', 1).catch(() => {});
    } catch (error) {
      // Keep error popup
      showNotification(`Failed to save progress: ${error.message}`, 'error');
    }
  };
  
  const handleUndo = (categoryIndex) => {
    // Show confirmation dialog first
    setConfirmUndo({ show: true, categoryIndex });
  };
  
  const confirmUndoAction = () => {
    const categoryIndex = confirmUndo.categoryIndex;
    const domainKey = getDomainKeyFromIndex(categoryIndex);
    
    // Update local state using the correct domain key
    const newProgress = {
      ...taskProgress,
      [domainKey]: Math.max((taskProgress[domainKey] || 0) - 1, 0)
    };
    
    setTaskProgress(newProgress);
    startFadeTimer(categoryIndex);
    
    // Save progress to backend using the appropriate API with correct domain key
    const saveProgress = async () => {
      try {
        if (trainingPath === 'IMT') {
          await saveIMTDomainProgress(domainKey, newProgress[domainKey]);
        } else if (trainingPath === 'CST') {
          await saveCSTDomainProgress(domainKey, newProgress[domainKey]);
        } else if (trainingPath === 'ACCS') {
          await saveACCSDomainProgress(domainKey, newProgress[domainKey]);
        } else if (trainingPath === 'Neurosurgery') {
          await saveNeuroSurgDomainProgress(domainKey, newProgress[domainKey]);
        } else if (trainingPath === 'Radiology') {
          await saveRadiologyDomainProgress(domainKey, newProgress[domainKey]);
        }
        // Remove success popup after undo update
        // showNotification('Progress updated successfully!', 'success');
        console.log(`${trainingPath} progress updated for ${domainKey}: ${newProgress[domainKey]}`);
        recordDailyActivity('task_update', 1).catch(() => {});
      } catch (error) {
        // Keep error popup
        showNotification(`Failed to update progress: ${error.message}`, 'error');
        console.error(`Error saving ${trainingPath} progress for ${domainKey}:`, error);
      }
    };
    
    saveProgress();
    
    // Close confirmation dialog
    setConfirmUndo({ show: false, categoryIndex: null });
  };
  
  const cancelUndoAction = () => {
    setConfirmUndo({ show: false, categoryIndex: null });
  };
  
  const handleHover = (categoryIndex, isHovering) => {
    clearTimeout(fadeTimeout.current[categoryIndex]);
    setFading(prev => ({ ...prev, [categoryIndex]: false }));

    if (!isHovering) {
      startFadeTimer(categoryIndex);
    }
  };

  // Add new function to handle task expansion
  const handleExpandTask = (categoryIndex, taskOffset) => {
    const domainKey = getDomainKeyFromIndex(categoryIndex);
    const category = allSteps[categoryIndex];
    const currentTaskIndex = getCurrentTaskIndex(categoryIndex);
    const absoluteIndex = currentTaskIndex + taskOffset;
    const taskText = category.steps[absoluteIndex];
    const details = getTaskDetails(category.category, taskText);

    const taskData = {
      categoryIndex,
      taskIndex: absoluteIndex,
      displayIndex: absoluteIndex + 1, // 1-based, consistent number for UI
      task: taskText,
      category: category.category,
      color: category.color,
      domainKey,
      progress: currentTaskIndex, // completed count
      total: category.steps.length,
      details, // include resolved details so the parent can render identical UI
      onComplete: () => handleTaskComplete(categoryIndex, 0),
    };

    if (onOpenTask) onOpenTask(taskData);
  };

  // Updated function to get task details
  const getTaskDetails = (categoryName, taskText) => {
    // For CST training path, use the specific task details
    if (trainingPath === 'CST' && cstTaskDetails[categoryName] && cstTaskDetails[categoryName][taskText]) {
      return cstTaskDetails[categoryName][taskText];
    }

    // For IMT training path, use the specific task details
    if (trainingPath === 'IMT' && imtTaskDetails[categoryName] && imtTaskDetails[categoryName][taskText]) {
      return imtTaskDetails[categoryName][taskText];
    }

    // For ACCS training path, use the specific task details
    if (trainingPath === 'ACCS' && accsTaskDetails[categoryName] && accsTaskDetails[categoryName][taskText]) {
      return accsTaskDetails[categoryName][taskText];
    }
    
    if (trainingPath === 'Neurosurgery' && neuroTaskDetails[categoryName] && neuroTaskDetails[categoryName][taskText]) {
      return neuroTaskDetails[categoryName][taskText];
    }
    
    if (trainingPath === 'Radiology' && radiologyTaskDetails[categoryName] && radiologyTaskDetails[categoryName][taskText]) {
      return radiologyTaskDetails[categoryName][taskText];
    }


    // Fall back to generic content for other training paths or missing data
    return {
      description: "This task involves completing specific requirements to demonstrate your competency in this area. Follow the steps carefully and document your progress.",
      requirements: [
        "Complete at least one relevant clinical case",
        "Obtain supervisor sign-off",
        "Document reflections on learning outcomes"
      ],
      steps: [
        { id: 1, text: "Identify suitable clinical scenarios", isCompleted: true },
        { id: 2, text: "Prepare necessary documentation", isCompleted: true },
        { id: 3, text: "Arrange assessment with supervisor", isCompleted: false },
        { id: 4, text: "Complete assessment", isCompleted: false },
        { id: 5, text: "Document and reflect on outcomes", isCompleted: false }
      ],
      comments: [
        { id: 1, author: "Dr. Smith", text: "Remember to focus on demonstrating key competencies during your assessment.", date: "2 days ago" },
        { id: 2, author: "Training Coordinator", text: "This assessment needs to be completed by the end of this rotation.", date: "1 week ago" }
      ],
      resources: [
        { title: "Assessment Form", type: "document", link: "#" },
        { title: "Competency Framework", type: "reference", link: "#" }
      ],
      qa: [
        { 
          question: "How long does this assessment typically take?", 
          answer: "Most trainees complete this assessment within 2-3 hours, including preparation time."
        },
        {
          question: "Can I complete this remotely?",
          answer: "No, this assessment requires in-person supervision by a qualified assessor."
        }
      ]
    };
  };

  // Updated task-item rendering (kept) — we no longer render internal overlay, we just call handleExpandTask
  return (
    <div className="info-box diagram-window">
      {/* Notification popup */}
      {notification.show && (
        <div className={`notification ${notification.type}`}>
          <span>{notification.message}</span>
          <button 
            className="notification-close" 
            onClick={() => setNotification(prev => ({ ...prev, show: false }))}
          >
            ×
          </button>
        </div>
      )}
      
      {/* Confirmation Dialog moved inline */}
      
      <div className="training-path-indicator">
        <span>
          {trainingPath === 'IMT' ? 'Internal Medicine Training' : 
           trainingPath === 'CST' ? 'Core Surgical Training' : 
           trainingPath === 'ACCS' ? 'Acute Care Common Stem' :
           trainingPath === 'Neurosurgery' ? 'Neurosurgery' :
           trainingPath === 'Radiology' ? 'Radiology' :
           trainingPath}
        </span>
      </div>
      
      <div className="tasks-grid">
        {allSteps.map((category, categoryIndex) => {
          const currentTaskIndex = getCurrentTaskIndex(categoryIndex);
          const visibleTasks = category.steps.slice(currentTaskIndex, currentTaskIndex + 3);
          const isFading = fading[categoryIndex] || false;

          return (
            <div key={categoryIndex} className="category-section">
              <div className="category-header">
                <ProgressBar 
                  progress={currentTaskIndex}
                  total={category.steps.length}
                  color={category.color}
                />
              </div>
              <div className="category-row">
                {visibleTasks.map((task, index) => {
                  // Calculate absolute step index to determine locking
                  const absoluteIndex = currentTaskIndex + index;
                  const isLocked = !isSubscribed && absoluteIndex >= 5;

                  return (
                    <div
                      key={currentTaskIndex + index}
                      className="task-item"
                      style={{
                        border: `1px solid ${index === 0 ? category.color + '30' : 'transparent'}`,
                        boxShadow: index === 0 ? `0 8px 24px -6px ${category.color}20` : 'none',
                        transform: `translateX(${index * 100}%) scale(${index === 0 ? 1 : 0.96})`,
                        opacity: index === 0 ? 1 : 0.5,
                        zIndex: 3 - index
                      }}
                    >
                      <div className="icon-container" style={{ backgroundColor: `${category.color}15`, color: category.color }}>
                        <category.icon className="task-icon" />
                      </div>
                      <div className="task-content">
                        <span className="task-category" style={{ color: category.color }}>{category.category}</span>
                        <div className="task-header-row">
                          <p className="task-text" style={isLocked ? { color: '#94a3b8' } : {}}>{task.replace(/^\d+\.\s/, '')}</p>
                          
                          {/* Only show expand button if not locked */}
                          {!isLocked && (
                            <button 
                              className="task-expand-btn" 
                              onClick={() => handleExpandTask(categoryIndex, index)}
                              aria-label="Expand task details"
                              title="View all task details"
                            >
                              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M15 3h6v6"></path>
                                <path d="M10 14L21 3"></path>
                                <path d="M9 18h4"></path>
                                <path d="M3 21h14v-9"></path>
                              </svg>
                              Deep Dive
                            </button>
                          )}
                        </div>
                        {isLocked && (
                          <div style={{ fontSize: '0.75rem', marginTop: '0.5rem', color: '#64748b', display: 'flex', alignItems: 'center', gap: '4px' }}>
                            <FaLock size={10} />
                            <span>
                              <Link to="/billing" style={{ color: category.color, fontWeight: 'bold', textDecoration: 'underline' }}>
                                Subscribe
                              </Link> to unlock next steps
                            </span>
                          </div>
                        )}
                      </div>
                      {isLocked ? (
                        <div style={{ marginTop: '0.25rem', padding: '4px' }}>
                          <FaLock color={category.color} size={18} style={{ opacity: 0.6 }} />
                        </div>
                      ) : (
                        <input
                          type="checkbox"
                          className="task-checkbox"
                          onChange={() => handleTaskComplete(categoryIndex, currentTaskIndex + index)}
                        />
                      )}
                    </div>
                  );
                })}
                {currentTaskIndex > 0 && (
                  <button
                    onClick={() => handleUndo(categoryIndex)}
                    className="undo-button"
                    style={{
                      backgroundColor: isFading ? '#eee' : `${category.color}15`,
                      color: isFading ? '#999' : category.color,
                      borderColor: isFading ? '#ddd' : `${category.color}30`,
                      transition: 'all 0.3s ease',
                      opacity: confirmUndo.show && confirmUndo.categoryIndex === categoryIndex ? 0 : 1,
                      pointerEvents: confirmUndo.show && confirmUndo.categoryIndex === categoryIndex ? 'none' : 'auto'
                    }}
                    onMouseEnter={() => handleHover(categoryIndex, true)}
                    onMouseLeave={() => handleHover(categoryIndex, false)}
                    title="Go back one task" // Added tooltip
                  >
                    <FaUndo size={12} />
                    <span>Undo</span>
                  </button>
                )}

                {confirmUndo.show && confirmUndo.categoryIndex === categoryIndex && (
                  <div className="undo-inline-confirmation">
                    <h4>Undo Task?</h4>
                    <p>Are you sure?</p>
                    <div className="undo-confirmation-buttons">
                      <button className="btn-cancel" onClick={cancelUndoAction}>Cancel</button>
                      <button className="btn-confirm" onClick={confirmUndoAction}>Yes</button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>

      <style jsx>{`
        .info-box {
          background: linear-gradient(135deg, rgba(255, 255, 255, 0.7) 0%, rgba(255, 255, 255, 0.4) 100%);
          backdrop-filter: blur(25px) saturate(180%);
          -webkit-backdrop-filter: blur(25px) saturate(180%);
          border: 1px solid rgba(255, 255, 255, 0.6);
          border-radius: 32px;
          padding: 32px;
          box-shadow: 
            0 20px 50px -12px rgba(0,0,0,0.1),
            inset 0 0 0 1px rgba(255, 255, 255, 0.3);
          position: relative;
          transition: all 0.3s ease;
        }

        .diagram-window {
          width: 100%;
          margin: 0 auto;
        }

        .training-path-indicator {
          background: rgba(255, 255, 255, 0.5);
          border: 1px solid rgba(255, 255, 255, 0.6);
          border-radius: 100px;
          padding: 0.6rem 1.5rem;
          margin-bottom: 2rem;
          text-align: center;
          font-weight: 600;
          color: #1d1d1f;
          font-size: 0.85rem;
          letter-spacing: -0.01em;
          display: inline-block;
          position: relative;
          left: 50%;
          transform: translateX(-50%);
          backdrop-filter: blur(10px);
          box-shadow: 0 4px 20px rgba(0,0,0,0.03);
        }

        .tasks-grid {
          display: flex;
          flex-direction: column;
          gap: 4rem;
        }

        .category-section {
          display: flex;
          flex-direction: column;
          gap: 0.75rem;
        }

        .category-header {
          padding: 0 0.25rem;
        }

        .category-row {
          position: relative;
          height: 120px;
          overflow: visible;
          display: flex;
          flex-wrap: nowrap;
          padding: 10px 0;
        }

        .task-item {
          position: relative;
          flex: 0 0 100%;
          min-height: 110px;
          display: flex;
          align-items: flex-start;
          gap: 1rem;
          background: linear-gradient(145deg, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.3));
          backdrop-filter: blur(12px);
          padding: 1.25rem;
          border-radius: 24px;
          border: 1px solid rgba(255, 255, 255, 0.5);
          transition: all 0.5s cubic-bezier(0.19, 1, 0.22, 1);
          box-shadow: 0 4px 15px rgba(0,0,0,0.02);
        }

        .task-item:not(:first-child) {
          pointer-events: none;
        }

        /* Interactive hover effect for the active card */
        .task-item:first-child:hover {
          background: linear-gradient(145deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.6));
          box-shadow: 
            0 15px 35px -5px rgba(0,0,0,0.08),
            0 5px 15px -5px rgba(0,0,0,0.04),
            inset 0 0 0 1px rgba(255, 255, 255, 0.5);
          border-color: rgba(255, 255, 255, 0.8);
          transform: translateY(-2px) scale(1.005);
        }

        .task-item:first-child:hover .icon-container {
          transform: scale(1.1) rotate(-5deg);
          background-color: rgba(255,255,255,0.5);
          box-shadow: 0 4px 12px rgba(0,0,0,0.05);
        }

        .icon-container {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 42px;
          height: 42px;
          border-radius: 14px;
          flex-shrink: 0;
          transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
          border: 1px solid rgba(255,255,255,0.2);
        }

        .task-icon {
          font-size: 1.1rem;
          color: inherit;
          margin-top: 0;
          filter: drop-shadow(0 2px 4px rgba(0,0,0,0.1));
        }

        .task-content {
          flex: 1;
          display: flex;
          flex-direction: column;
          min-height: 70px;
          position: relative;
          padding-bottom: 0;
        }

        .task-category {
          display: block;
          font-size: 0.65rem;
          font-weight: 800;
          text-transform: uppercase;
          letter-spacing: 0.05em;
          margin-bottom: 0.25rem;
          opacity: 0.8;
          text-shadow: 0 1px 0 rgba(255,255,255,0.5);
        }

        .task-header-row {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          gap: 0.75rem;
          width: 100%;
        }

        .task-text {
          font-size: 0.95rem;
          color: #1d1d1f;
          margin: 0;
          line-height: 1.4;
          font-weight: 500;
          flex: 1;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
          transition: color 0.2s ease;
        }

        .task-checkbox {
          width: 1.4rem;
          height: 1.4rem;
          border-radius: 50%;
          border: 2px solid rgba(0,0,0,0.1);
          background: rgba(255,255,255,0.5);
          cursor: pointer;
          margin-top: 0.25rem;
          appearance: none;
          transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
          flex-shrink: 0;
          position: relative;
          box-shadow: inset 0 2px 4px rgba(0,0,0,0.05);
        }

        .task-checkbox:checked {
          background-color: #0071e3;
          border-color: #0071e3;
          background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/%3e%3c/svg%3e");
          transform: scale(1.1);
          box-shadow: 0 4px 12px rgba(0, 113, 227, 0.3);
        }

        .task-checkbox:hover {
          border-color: #0071e3;
          transform: scale(1.1);
          background: white;
        }
        
        .task-checkbox:checked:hover {
          transform: scale(1.05);
          background-color: #0077ed;
        }

        /* Notification popup styles */
        .notification {
          position: fixed;
          top: 24px;
          right: 24px;
          padding: 16px 24px;
          border-radius: 20px;
          background: rgba(255, 255, 255, 0.8);
          backdrop-filter: blur(20px) saturate(180%);
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
          z-index: 1000;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 16px;
          animation: slideIn 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards;
          border: 1px solid rgba(255,255,255,0.5);
        }

        .notification.success {
          color: #008040;
          background: linear-gradient(135deg, rgba(240, 253, 244, 0.9), rgba(255, 255, 255, 0.8));
        }

        .notification.error {
          color: #d70015;
          background: linear-gradient(135deg, rgba(254, 242, 242, 0.9), rgba(255, 255, 255, 0.8));
        }

        .notification.info {
          color: #0071e3;
          background: linear-gradient(135deg, rgba(239, 246, 255, 0.9), rgba(255, 255, 255, 0.8));
        }

        .notification-close {
          background: rgba(0,0,0,0.05);
          border: none;
          cursor: pointer;
          font-size: 16px;
          width: 24px;
          height: 24px;
          border-radius: 50%;
          color: currentColor;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: background 0.2s;
        }

        .notification-close:hover {
          background: rgba(0,0,0,0.1);
        }

        @keyframes slideIn {
          from {
            transform: translateY(-20px);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }

        .undo-inline-confirmation {
          position: absolute;
          bottom: -60px;
          left: 50%;
          transform: translateX(-50%);
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(20px);
          border-radius: 16px;
          padding: 1rem;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
          z-index: 100;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 0.5rem;
          border: 1px solid rgba(0,0,0,0.1);
          min-width: 200px;
          animation: popIn 0.3s cubic-bezier(0.16, 1, 0.3, 1);
        }

        .undo-inline-confirmation h4 {
          margin: 0;
          font-size: 0.9rem;
          color: #1d1d1f;
          font-weight: 600;
        }

        .undo-inline-confirmation p {
          margin: 0 0 0.5rem 0;
          font-size: 0.75rem;
          color: #86868b;
        }

        @keyframes popIn {
          from { opacity: 0; transform: translateX(-50%) scale(0.9); }
          to { opacity: 1; transform: translateX(-50%) scale(1); }
        }

        /* Undo confirmation - replaced overlay styles */
        .undo-confirmation-buttons {
          display: flex;
          justify-content: center;
          gap: 0.5rem;
        }

        .btn-cancel {
          padding: 0.4rem 1rem;
          background: rgba(0,0,0,0.05);
          border: none;
          border-radius: 100px;
          color: #1d1d1f;
          font-size: 0.75rem;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s ease;
        }

        .btn-confirm {
          padding: 0.4rem 1rem;
          background: #ff3b30;
          border: none;
          border-radius: 100px;
          color: white;
          font-size: 0.75rem;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s ease;
          box-shadow: 0 4px 10px rgba(255, 59, 48, 0.25);
        }

        .btn-cancel:hover {
          background: rgba(0,0,0,0.1);
        }

        .btn-confirm:hover {
          background: #d70015;
          transform: translateY(-1px);
          box-shadow: 0 6px 15px rgba(255, 59, 48, 0.35);
        }

        .undo-button {
          position: absolute;
          bottom: -45px;
          left: 50%;
          transform: translateX(-50%);
          display: flex;
          align-items: center;
          gap: 0.5rem;
          padding: 0.6rem 1.4rem;
          border-radius: 100px;
          border: 1px solid rgba(255,255,255,0.6);
          font-size: 0.75rem;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
          animation: fadeIn 0.5s ease-out;
          box-shadow: 0 8px 20px rgba(0,0,0,0.06);
          background: rgba(255,255,255,0.8);
          backdrop-filter: blur(10px);
        }

        .undo-button:hover {
          transform: translateX(-50%) translateY(-3px);
          box-shadow: 0 12px 25px rgba(0,0,0,0.1);
          background: white;
        }

        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        @keyframes scaleIn {
          from { 
            opacity: 0;
            transform: scale(0.9);
          }
          to { 
            opacity: 1;
            transform: scale(1);
          }
        }

        /* Add styles for the expand button */
        .task-expand-btn {
          display: inline-flex;
          align-items: center;
          gap: 4px;

          /* purple treatment */
          --pf-purple: #7c3aed;
          --pf-purple-20: rgba(124, 58, 237, 0.20);
          --pf-purple-35: rgba(124, 58, 237, 0.35);

          background: rgba(255,255,255,0.55);
          border: 1px solid var(--pf-purple-35);
          border-radius: 100px;
          padding: 5px 12px;
          font-size: 0.65rem;
          font-weight: 700;
          color: var(--pf-purple);

          cursor: pointer;
          transition: all 0.2s ease;
          flex-shrink: 0;
          margin-top: 0;
          box-shadow: 0 2px 8px rgba(0,0,0,0.03);
        }

        .task-expand-btn:hover {
          background: var(--pf-purple);
          color: #ffffff;
          transform: translateY(-1px);
          border-color: rgba(255,255,255,0.25);
          box-shadow: 0 10px 22px rgba(124, 58, 237, 0.28);
        }

        .task-expand-btn:active {
          transform: translateY(0);
          box-shadow: 0 6px 16px rgba(124, 58, 237, 0.22);
        }

        .task-expand-btn:focus-visible {
          outline: none;
          box-shadow:
            0 0 0 3px var(--pf-purple-20),
            0 10px 22px rgba(124, 58, 237, 0.22);
        }

        .task-expand-btn svg {
          width: 10px;
          height: 10px;
        }

        .pf-journey-container {
          width: 100%;
          overflow: hidden;
          padding: 1rem 0.5rem; /* Added padding to prevent clipping of shadows/buttons */
        }
        
        .pf-stages-track {
          display: flex;
          transition: transform 0.5s cubic-bezier(0.25, 1, 0.5, 1);
          width: max-content;
          padding-left: 1rem;
        }

        .pf-stage-box {
          width: 310px; /* Fixed width */
          margin-right: 50px; /* Increased gap between boxes */
          flex-shrink: 0;
          background: #ffffff;
          border-radius: 16px;
          border: 1px solid #e2e8f0;
          display: flex;
          flex-direction: column;
          position: relative;
          transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
          overflow: visible; /* Ensure undo button isn't clipped */
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
        }

        .pf-stage-header {
          padding: 1.25rem 1.5rem;
          border-bottom: 1px solid #f1f5f9;
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          position: relative;
          overflow: visible; /* Ensure header doesn't clip button */
        }

        .pf-stage-title {
          font-size: 1.125rem;
          font-weight: 600;
          color: #1d1d1f;
          margin: 0;
          position: relative;
          display: inline-block;
          padding-bottom: 4px;
        }

        .pf-stage-title:after {
          content: '';
          position: absolute;
          width: 100%;
          height: 2px;
          bottom: 0;
          left: 0;
          background: linear-gradient(90deg, transparent, #0071e3, transparent);
          z-index: 1;
        }

        .pf-stage-content {
          padding: 1rem 1.5rem;
          flex: 1;
          display: flex;
          flex-direction: column;
          gap: 1rem;
        }

        .pf-progress-bar {
          height: 8px;
          border-radius: 4px;
          overflow: hidden;
          background: rgba(0, 0, 0, 0.05);
          border: 1px solid rgba(255, 255, 255, 0.2);
        }

        .pf-progress-fill {
          height: 100%;
          border-radius: 4px;
          transition: width 0.4s ease;
          background: linear-gradient(90deg, #0071e3, #00c8ff);
        }

        .pf-task-list {
          display: flex;
          flex-direction: column;
          gap: 0.5rem;
        }

        .pf-task-item {
          padding: 0.8rem 1.2rem;
          border-radius: 12px;
          background: rgba(255, 255, 255, 0.8);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.3);
          display: flex;
          align-items: center;
          justify-content: space-between;
          position: relative;
          transition: transform 0.3s ease;
        }

        .pf-task-item:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }

        .pf-task-icon {
          font-size: 1.2rem;
          color: #0071e3;
          margin-right: 0.75rem;
        }

        .pf-task-details {
          flex: 1;
          display: flex;
          flex-direction: column;
        }

        .pf-task-name {
          font-size: 0.9rem;
          font-weight: 500;
          color: #1d1d1f;
          margin: 0;
        }

        .pf-task-description {
          font-size: 0.75rem;
          color: #4a5568;
          margin: 0;
          flex: 1;
        }

        .pf-task-meta {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 0.5rem;
        }

        .pf-task-progress {
          font-size: 0.75rem;
          color: #2d3748;
        }

        .pf-task-complete-btn {
          padding: 0.4rem 0.8rem;
          border-radius: 100px;
          background: #48bb78;
          color: white;
          font-size: 0.75rem;
          font-weight: 600;
          border: none;
          cursor: pointer;
          transition: background 0.3s ease;
          position: absolute;
          right: 1rem;
          top: 50%;
          transform: translateY(-50%);
          box-shadow: 0 4px 12px rgba(72, 187, 120, 0.3);
        }

        .pf-task-complete-btn:hover {
          background: #38a169;
        }

        /* Responsive styles */
        @media (max-width: 768px) {
          .info-box {
            padding: 10px 20px; /* Reduced vertical padding */
          }

          .training-path-indicator {
            padding: 0.4rem 1rem;
            font-size: 0.75rem;
            width: 90%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .category-row {
            height: auto;
            min-height: 140px;
            padding-bottom: 10px;
          }

          .task-item {
            flex-direction: row;
            align-items: flex-start;
            gap: 0.75rem;
            padding: 1.25rem 1rem;
            height: auto;
            min-height: 140px;
          }

          .icon-container {
            width: 36px;
            height: 36px;
          }

          .task-icon {
            font-size: 0.9rem;
          }

          .task-content {
            min-height: auto;
            padding-right: 0.25rem;
            min-width: 0; /* Prevents text overflow in flex container */
          }

          .task-header-row {
            flex-direction: column;
            align-items: flex-start;
            gap: 0.75rem;
          }

          .task-text {
            font-size: 0.85rem;
            -webkit-line-clamp: 4;
            word-break: break-word; /* Prevents horizontal bleeding */
          }

          .task-checkbox {
            width: 1.3rem;
            height: 1.3rem;
            margin-top: 0.1rem;
          }

          .undo-button {
            padding: 0.5rem 1.2rem;
            font-size: 0.7rem;
            bottom: -35px;
          }

          .task-expand-btn {
            padding: 5px 10px;
            font-size: 0.7rem;
            margin-top: 0.25rem;
            width: auto;
            background: rgba(255,255,255,0.6);
            align-self: flex-start;
            border-color: rgba(124, 58, 237, 0.35);
            color: #7c3aed;
          }

          .pf-stage-box {
            width: 100%;
            margin-right: 0;
            border-radius: 16px;
          }

          .pf-stage-header {
            padding: 1rem;
          }

          .pf-stage-title {
            font-size: 1rem;
          }

          .pf-task-complete-btn {
            padding: 0.3rem 0.6rem;
            font-size: 0.7rem;
          }
        }
      `}</style>
    </div>
  );
};

export default PathfinderJourneyStageProgressionBoxes;